// 自定义截断组件
<template>
  <div class="clamp-container" :style="{ height: height + 'rem' }" ref="box">
    <p ref="p" v-html="clampTxt" />
    <span class="cover" v-show="clamp" :style="{ backgroundColor: coverColor }"
      >...</span
    >
  </div>
</template>

<script>
export default {
  name: 'selfVueClamp',
  props: {
    'max-lines': {
      type: Number,
      default: 1
    },
    clampTxt: {
      type: String,
      default: ''
    },
    coverColor: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      height: 1,
      clamp: false
    }
  },
  created() {
    this.height = this.maxLines * 1.5
    this.$nextTick(() => {
      const p_height = window.getComputedStyle(this.$refs['p']).height
      const box_height = window.getComputedStyle(this.$refs['box']).height
      this.clamp = parseFloat(p_height) > parseFloat(box_height)
    })
  }
}
</script>

<style lang="less" scoped>
.clamp-container {
  overflow: hidden;
  line-height: 1.5rem;
  position: relative;
  .cover {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0 2px;
    // background-color: #fff;
  }
}
</style>